import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import HeroBanner from './HeroBanner';
import LoginForm from './LoginForm';
import PasswordResetForm from './PasswordResetForm';
import toast from 'react-hot-toast';

export default function SlotsSignIn() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [resetError, setResetError] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [showReset, setShowReset] = useState(false);

  const handleSignIn = async (formData) => {
    const { email, password } = formData;

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    else navigate("/dashboard");
  };

  const handleForgotPassword = async (email) => {
    setResetError('');
    setResetMessage('');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setResetError('Please enter a valid email address.');
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/user/request-password-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result.error || 'Unknown error');

      setResetMessage('Password reset email sent! Check your inbox.');
    } catch (err) {
      setResetError(err.message);
    }
  };

  const handleBackToLogin = () => {
    setShowReset(false);
    setResetError('');
    setResetMessage('');
    setError('');
  };

  const handleShowReset = () => {
    setShowReset(true);
    setError('');
  };

  // Configuration for the customizable hero banner
  const heroBannerConfig = {
    logoSrc: "https://cdn.shopify.com/s/files/1/0261/6318/3691/files/Maniko_logo.png?v=1693840112",
    logoAlt: "MANIKO Logo",
    logoWidth: '220px',
    title: null, // No title for login page
    subtitle: showReset 
      ? "Enter your email to receive a password reset link."
      : "Please enter your information below to log in.",
    backgroundColor: '#f9f9f9',
    
    // Primary button is handled by the forms
    primaryButton: {
      show: false,
    },
    
    // Secondary button for additional actions
    secondaryButton: {
      show: !showReset,
      text: "Need an account? Contact Admin",
      color: 'transparent',
      hoverColor: '#f0f0f0',
      textColor: '#666',
      hoverTextColor: '#333',
      width: '100%',
      variant: 'text',
      onClick: () => {
        // You can customize this action - maybe open a modal or navigate somewhere
        toast.info('Please contact your administrator for account creation');
      },
    },
    
    // Mobile responsive settings
    mobileSettings: {
      logoWidth: '180px',
      titleFontSize: '1.5rem',
      subtitleFontSize: '1rem',
      containerPadding: 2,
    },
  };

  return (
    <>
      <HeroBanner
        {...heroBannerConfig}
      >
        {!showReset ? (
          <LoginForm
            onSubmit={handleSignIn}
            onForgotPassword={handleShowReset}
            error={error}
          />
        ) : (
          <PasswordResetForm
            onSubmit={handleForgotPassword}
            onBackToLogin={handleBackToLogin}
            error={resetError}
            successMessage={resetMessage}
          />
        )}
      </HeroBanner>
    </>
  );
}
